export default __webpack_public_path__ + "static/media/218692-NTRA-NHC-Background.8824bf69.png";